import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import useSWR from 'swr';

import { useLayout } from '../layout/context';
import iconSrc from '../../utils/iconSrc';
import { Icon, Item, Image, ImageContainer, Feed } from './styles';
import { Heading2 } from '../styled/typography';
import { Container } from '../styled/containers';

const fetchInstagramFeed = (id) =>
  axios
    .get(`/.netlify/functions/instagram-feed`, {
      params: { id },
    })
    .then((data) => data.data);

// eslint-disable-next-line camelcase
const InstagramFeed = ({ heading, posts }) => {
  const { insideSideBar, insideContainer } = useLayout();

  return (
    <Container $padding={!insideContainer}>
      {heading && <Heading2>{heading}</Heading2>}
      <Feed $vertical={insideSideBar}>
        {posts.map(({ url, link, caption }) => (
          <Item key={url} href={link}>
            <ImageContainer>
              <Image src={url} alt={caption} />
            </ImageContainer>
            <Icon src={iconSrc('social-instagram')} />
          </Item>
        ))}
      </Feed>
    </Container>
  );
};

InstagramFeed.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      caption: PropTypes.string,
    }).isRequired
  ),
  heading: PropTypes.string,
};

export default InstagramFeed;

const InstagramFeedSkeleton = ({ posts, heading }) => {
  const { insideSideBar, insideContainer } = useLayout();

  return (
    <Container $padding={!insideContainer}>
      {heading && <Heading2>{heading}</Heading2>}
      <Feed $vertical={insideSideBar}>
        {Array(posts)
          .fill(0)
          .map((_, index) => (
            <Item key={index} as="div">
              <ImageContainer />
            </Item>
          ))}
      </Feed>
    </Container>
  );
};

InstagramFeedSkeleton.propTypes = {
  posts: PropTypes.number.isRequired,
  heading: PropTypes.string,
};

export const InstagramFeedAssembly = ({ contentfulData }) => {
  const { data, error, isLoading } = useSWR(
    contentfulData.contentful_id,
    fetchInstagramFeed
  );

  if (error || (data && data.length === 0)) return null;

  if (isLoading) {
    return (
      <InstagramFeedSkeleton
        heading={contentfulData.heading}
        posts={contentfulData.maxPosts || 3}
      />
    );
  }

  return (
    <InstagramFeed
      heading={contentfulData.heading}
      posts={data.slice(0, contentfulData.maxPosts || 3)}
      contentful_id=""
    />
  );
};

InstagramFeedAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
